import t from "./index631.js";
import { withInstall as r } from "./index604.js";
const a = r(t);
export {
  a as ElDatePicker,
  a as default
};
